module.exports = __webpack_public_path__ + "5a5ec11f8065dcec9006ed8f82e72bb0.png";